export type StockStatus =
  | "available"
  | "in-stock"
  | "low-stock"
  | "out-of-stock";

export function getStockDisplay({
  initStock,
  type,
  showStock,
  canBackorder,
}: {
  initStock: number;
  type: "full" | "short" | "minimal";
  showStock: boolean;
  canBackorder?: boolean;
}): {
  status: StockStatus;
  stockQuantity: string;
  textColor: "text-red-800" | "text-amber-800" | "text-green-800";
  backgroundColor: "bg-red-200" | "bg-amber-100" | "bg-green-200";
} {
  if (canBackorder) {
    return {
      status: "available",
      stockQuantity: "Available",
      textColor: "text-green-800",
      backgroundColor: "bg-green-200",
    };
  }

  if (initStock > 10) {
    return {
      status: "in-stock",
      stockQuantity:
        type === "full"
          ? ["In stock", showStock && "(10+)"].filter(Boolean).join(" ")
          : "10+",
      textColor: "text-green-800",
      backgroundColor: "bg-green-200",
    };
  }

  if (initStock > 0) {
    return {
      status: "low-stock",
      stockQuantity:
        type === "full"
          ? ["Low stock", showStock && `(${initStock})`]
              .filter(Boolean)
              .join(" ")
          : initStock.toString(),
      textColor: "text-amber-800",
      backgroundColor: "bg-amber-100",
    };
  }

  return {
    status: "out-of-stock",
    stockQuantity: type === "full" ? "Sold out" : "0",
    textColor: "text-red-800",
    backgroundColor: "bg-red-200",
  };
}
